import { Anchor, ArrowLeftIcon, Button, Callout, Flex, Text, Title } from 'libs/uikit/lib';
import { ExternalLink } from 'libs/uikit/lib/ExternalLink/ExternalLink';
import React from 'react';
import { Link } from 'react-router-dom';

export function PasswordResetSentConfirmation() {
  return (
    <Flex gap={2} align="stretch">
      <Title size="h1" bold>
        Password reset email has been sent
      </Title>

      <Text>If a matching account exists then a password reset email will have been sent.</Text>

      <Text>
        Please check the inbox of the email address you entered. Unfortunately these emails can sometimes go through to
        spam or junk email too, so please check your spam just in case.
      </Text>

      <Anchor as={Link} to="/account/login" noUnderline>
        <Button primary iconLeft={ArrowLeftIcon}>
          Back to log in
        </Button>
      </Anchor>

      <Callout intent="secondary">
        <Flex gap={1} justify="space-between" align="center" horizontal>
          <Text bold scale={-1}>
            Still can't log in?
          </Text>
          <ExternalLink href="https://www.eventspass.co/contact-us/" noUnderline noIcon>
            <Button light variant="outlined" scale={-1}>
              Contact us
            </Button>
          </ExternalLink>
        </Flex>
      </Callout>
    </Flex>
  );
}
